import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";

import { AutoSaveField as Field, InlineRadioGroup } from "../../../../components/Form";
import { ContinueButton } from "../../../../components/Buttons/ContinueButton";
import { Divider } from "../Divider";
import { YesNoList } from "../../../../constants/options";

import { useStyles } from "./styled";

export const authorizationPreferencesSchema = Yup.object({
  marketing: Yup.string()
    .nullable()
    .required("This field is required"),
  networkInternationalCustomer: Yup.string()
    .nullable()
    .required("This field is required")
});

export const AuthorizationPreferencesComponent = ({ goToNext, createFormChangeHandler }) => {
  const classes = useStyles();
  return (
    <Formik
      initialValues={{
        networkInternationalCustomer: "",
        marketing: ""
      }}
      validationSchema={authorizationPreferencesSchema}
      validateOnChange={false}
      onSubmit={goToNext}
    >
      {createFormChangeHandler(() => (
        <Form>
          <Field
            name="networkInternationalCustomer"
            path="prospect.channelServicesInfo.networkInternationalCustomer"
            label="Are you a Network International customer?"
            component={InlineRadioGroup}
            options={YesNoList}
          />
          <Divider />
          <Field
            name="marketing"
            path="prospect.channelServicesInfo.marketing"
            label="Would you like to be the first to hear about the latest offers (including from RAKBANK's authorized third parties), including partner-provided payment solutions such as POS, Pay-by-Link, Payment gateway services etc?"
            component={InlineRadioGroup}
            options={YesNoList}
          />
          <div className={classes.buttonWrapper}>
            <ContinueButton type="submit" />
          </div>
        </Form>
      ))}
    </Formik>
  );
};
